import React from "react";
import { observer } from "mobx-react-lite";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./styles/style.css";
import "./styles/jdSlider.min.css";
import { CheckoutForm } from "./components/CheckoutForm";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { NavigationInjector } from "./stores/NavigationInjector";
import { Menu } from "./components/Menu";
import { Catalogo } from "./pages/Catalogo";
import { Loja } from "./pages/Loja";
import { Contato } from "./pages/Contato";
import { Product } from "./pages/Product";
import { CartPage } from "./pages/CartPage";
import { CheckOrder } from "./pages/CheckOrder";
import { OrderDetails } from "./pages/OrderDetails";
import { AdminPage } from "./pages/AdminPage";

export const App = observer(() => {
  const isAdminPage = location.pathname.startsWith("/gerenciar");
  const isCheckOrderPage = location.pathname.startsWith("/pedido_detalhes");
  const showMenu = !isAdminPage && !isCheckOrderPage && !isCheckOrderPage;

  return (
    <Router>
      <NavigationInjector />
      <Header isAdminPage={isAdminPage} />
      {showMenu && <Menu />}
      <main>
        <Routes>
          <Route path="/" element={<Catalogo />} />
          <Route path="/gerenciar/*" element={<AdminPage />} />
          <Route path="/loja" element={<Loja />} />
          <Route path="/contato" element={<Contato />} />
          <Route path="/consultar_pedidos" element={<CheckOrder />} />
          <Route path="/pedido_detalhes" element={<OrderDetails />} />
          <Route path="/carrinho" element={<CartPage />} />
          <Route path="/product/:id" element={<Product />} />

          <Route path="/checkout" element={<CheckoutForm />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
});
